import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/services/api'
import auth from './modules/auth'
import group from './modules/group'
import CurrentGroup from '@/models/CurrentGroup'
import Group from '@/models/Group'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    group
  },
  state: {
    calendar: {
      action: '',
      options: {
        events: [],
        fixedWeekCount: false,
        contentHeight: 'auto',
        eventDisplay: 'list-item',
        showNonCurrentDates: false,
        initialView: 'dayGridMonth',
        timeZone: '',
        titleFormat: { year: 'numeric', month: 'short' },
        headerToolbar: { start: 'title', center: '', end: 'prev,next' },
        footerToolbar: { start: '', center: '', end: 'today' }
      },
      eventDetails: {},
      utcOffset: ''
    },
    homeStats: {
      active_ltgs: 0,
      students: 0,
      projects: 0,
      stories: 0
    },
    mapGroups: [],
    currentGroup: null,
    notifications: {
      countUpdate: false,
      unread: null,
      previousUnread: 0,
      externalUserId: null,
      isInit: false
    },
    notifications_msgs: {
      countUpdate: false,
      unread: null,
      previousUnread: 0,
      externalUserId: null,
      isInit: false
    }
  },
  mutations: {
    setHomeStats(state, stats) {
      state.homeStats = stats
    },
    setMapGroups(state, groups) {
      state.mapGroups = groups
    },
    setCurrentGroup(state, group) {
      state.currentGroup = group
    },
    setNotificationUnread(state, count) {
      state.notifications.unread = count
      if (state.notifications.unread !== state.notifications.previousUnread) {
        state.notifications.countUpdate = true
        state.notifications.previousUnread = count
        setTimeout(() => {
          state.notifications.countUpdate = false
        }, 3000)
      }
    },
    setNotificationUnreadMessages(state, count) {
      state.notifications_msgs.unread = count
      if (
        state.notifications_msgs.unread !==
        state.notifications_msgs.previousUnread
      ) {
        state.notifications_msgs.countUpdate = true
        state.notifications_msgs.previousUnread = count
        setTimeout(() => {
          state.notifications_msgs.countUpdate = false
        }, 3000)
      }
    },
    setNotificationExtId(state, id) {
      state.notifications.externalUserId = id
    },
    setNotificationInit(state, value) {
      state.notifications.isInit = value
    },
    setCalendarMasterEvents(state, events) {
      state.calendar.options.events = events
    },
    setCalendarTimezone(state, tz) {
      state.calendar.options.timeZone = tz
    },
    setCalendarEventDetails(state, event) {
      state.calendar.eventDetails = event
    },
    setCalendarAction(state, action) {
      state.calendar.action = action
    },
    setCalendarUtcOffset(state, offset) {
      if (offset >= 0) {
        state.calendar.utcOffset = '+' + offset
      } else {
        state.calendar.utcOffset = offset
      }
    }
  },
  actions: {
    getHomeStats({ commit }) {
      return api.get('/home-stats').then(({ data }) => {
        commit('setHomeStats', data.data)
      })
    },

    getMapGroups({ commit }) {
      return api
        .get('/group-map', { params: { sort: '-current-group' } })
        .then(({ data }) => {
          commit('setMapGroups', data.data)
        })
    },

    getCurrentGroup({ commit }) {
      return CurrentGroup.include('members', 'values', 'cover')
        .first()
        .then(res => {
          commit('setCurrentGroup', new Group(res))
        })
        .catch(error => {
          if (error.response.status === 404) {
            return false
          }
        })
    },

    getUnreadNotifications({ commit }) {
      return api
        .get(`/notifications/unread-count?filter[type_exclude]=message_leaders`)
        .then(({ data }) => {
          commit('setNotificationUnread', data.count)
        })
        .finally(() => {})
    },

    getUnreadMessages({ commit }) {
      return api
        .get(`/notifications/unread-count?filter[type]=message_leaders`)
        .then(({ data }) => {
          commit('setNotificationUnreadMessages', data.count)
        })
        .finally(() => {})
    },

    getCalendarMasterEvents({ commit }) {
      return new Promise(resolve => {
        api.get(`/events`).then(async ({ data }) => {
          await commit('setCalendarMasterEvents', data.data)
          resolve()
        })
      })
    },

    getCalendarMasterSingleEvent({ commit }, eventId) {
      return new Promise(resolve => {
        api.get(`/events/${eventId}`).then(async ({ data }) => {
          commit('setCalendarEventDetails', data.data)
          resolve(data.data)
        })
      })
    }
  }
})
